import React, { useState, useEffect } from 'react';

const COOKIE_CONSENT_KEY = 'promotly_cookie_consent';

function loadGTM() {
  if (window.google_tag_manager && window.google_tag_manager['GTM-KLNNRD79']) return;
  const s = document.createElement('script');
  s.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-KLNNRD79');`;
  document.head.appendChild(s);
  const n = document.createElement('noscript');
  n.innerHTML = '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KLNNRD79" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
  document.body.appendChild(n);
}

function loadTikTokPixel() {
  if (window.ttq && window.ttq.load) return;
  const s = document.createElement('script');
  s.innerHTML = `!function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};ttq.load('D9EEA5RC77U2EG6DN200');ttq.page({content_id: 'landing_page', content_type: 'homepage'});ttq.track('ViewContent',{content_id:'landing_page',content_type:'homepage',content_name:'Promotly Landing Page'});}(window,document,'ttq');`;
  document.head.appendChild(s);
}

function loadFacebookPixel() {
  if (window.fbq) return;
  const s = document.createElement('script');
  s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','993466670351780');fbq('track','PageView');`;
  document.head.appendChild(s);
  const n = document.createElement('noscript');
  n.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=993466670351780&ev=PageView&noscript=1"/>';
  document.body.appendChild(n);
}

function loadLinkedIn() {
  if (window.lintrk && window.lintrk.q) return;
  window._linkedin_partner_id = '10518777';
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push('10518777');
  (function(l) {
    if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
    window.lintrk.q=[]}
    var s = document.getElementsByTagName('script')[0];
    var b = document.createElement('script');
    b.type = 'text/javascript';b.async = true;
    b.src = 'https://snap.licdn.com/li.lms-analytics/insight.old.min.js';
    s.parentNode.insertBefore(b, s);
  })(window.lintrk);
}

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (consent === 'accepted') {
      loadGTM();
      loadLinkedIn();
      loadTikTokPixel();
      loadFacebookPixel();
    } else if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    loadGTM();
    loadLinkedIn();
    loadTikTokPixel();
    loadFacebookPixel();
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-slate-900 border-t border-slate-700 shadow-2xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-1 text-sm text-gray-300">
            <p>
              We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, and support our marketing efforts. 
              Essential cookies are always active. Non-essential cookies (analytics, marketing) are only placed with your consent.
            </p>
            <p className="mt-1">
              <a href="/privacy-policy" className="text-teal-400 hover:text-teal-300 underline" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              <span className="mx-2 text-gray-500">|</span>
              <a href="/terms" className="text-teal-400 hover:text-teal-300 underline" target="_blank" rel="noopener noreferrer">Terms of Service</a>
            </p>
          </div>
          <div className="flex flex-wrap gap-3 shrink-0 max-w-full">
            <button
              onClick={decline}
              className="px-5 py-2 rounded-lg text-sm font-medium text-gray-300 bg-slate-700 hover:bg-slate-600 transition-colors"
            >
              Decline
            </button>
            <button
              onClick={accept}
              className="px-5 py-2 rounded-lg text-sm font-medium text-white bg-teal-600 hover:bg-teal-500 transition-colors"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
